import { Grid, Paper, Tooltip, Typography } from '@material-ui/core';
import { useSnackbarInstance } from '@lib/common';
import { useMemo } from 'react';
import { Column } from 'react-table';
import { DraggableRowsTable } from '@components/draggable-rows-table';
import { ImDrawer2 } from '@icon/react-icons';
import { createContextQuick } from '@components/quick-context';
import { createFormField } from '../../common';
import { GroupCompanies } from '@lib/company';
import styled from 'styled-components';
import { thumbStack } from '@lib/common/css';

export const GroupCompaniesLoader = ({ value = null, onChange = null, similarClick = null }) => {
  const { enqueue } = useSnackbarInstance();

  const GroupCompanyColumn: Column<GroupCompanies>[] = useMemo(
    () => [
      {
        Header: '#',
        id: 'serial',
        accessor: (_row, idx) => idx + 1,
        width: 35,
      },
      {
        Header: 'Vitrina Company Name',
        id: 'vtr_company_name',
        accessor: row => row.vtr_company_name,
        width: 200,
      },
      {
        Header: 'Vitrina Id',
        id: 'company1_vtr_id',
        accessor: row => row.company1_vtr_id,
        width: 85,
      },
    ],
    []
  );

  return (
    <GroupCompaniesContainer>
      <Grid container spacing={4} justify="center" alignItems="center">
        <Grid item>
          <Typography variant="h6" style={{ fontSize: 16 }}>
            Manage Group Companies
          </Typography>
        </Grid>
        <Grid item xs />
      </Grid>
      {value && value.length ? (
        <Paper className="fixed-height">
          <ProvideEdit
          // deleteBadge={onBadgeDelete}
          // editBadge={onEditBadge}
          // onSimilarClick={similarClick}
          >
            <DraggableRowsTable
              getRowId={getGroupCompanyRowId}
              onChange={onChange}
              columns={GroupCompanyColumn}
              data={value}
              stickyHeader
              size="small"
              showDragIcon={false}

              // stopDrag={true}
            />
          </ProvideEdit>
        </Paper>
      ) : (
        EmptyContent
      )}
    </GroupCompaniesContainer>
  );
};

const EmptyContent = (
  <Paper className="fixed-height no-data">
    <span>
      <ImDrawer2 />
      <br />
      <Typography>
        Click on <strong>Add</strong> button
        <br />
        and start managing Group Companies.
      </Typography>
    </span>
  </Paper>
);

const [ProvideEdit, useActions] =
  createContextQuick<{
    deleteGroupCompany?: (vtr_company: GroupCompanies) => any;
    editGroupCompany?: (vtr_company: GroupCompanies, idx?: number) => any;
  }>();
const getGroupCompanyRowId = row => row.company1_vtr_id;

export const GroupCompaniesField = createFormField(GroupCompaniesLoader, {
  defaultValue: [],
  passProps: true,
});

const GroupCompaniesContainer = styled.div`
  padding: 10px 5px;
  background: #f5f5f5;
  table {
    td:nth-of-type(1) {
      padding-left: 10px;
      width: 40px;
    }
    th:nth-of-type(1) {
      padding-left: 10px;
      width: 40px;
    }
    // td:nth-of-type(2) {
    //   width: 35px;
    // }
    td:last-child {
      width: 80px;
    }
  }
  .drag-icon {
    cursor: grab;
  }
  .fixed-height {
    ${thumbStack}
    margin-top: 6px;
    margin-bottom: 6px;
    height: 40vh;
    position: relative;
    overflow: auto;
    .MuiTableContainer-root {
      ${thumbStack}
      height: inherit;
      overflow: inherit;
    }
    &.no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        text-align: center;
        svg {
          font-size: 4em;
          color: #ccc;
        }
      }
    }
  }
`;
